import type { ReactNode } from "react";

interface ModuleCardProps {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  /** Renders as a non-clickable, dimmed card with a planned badge. */
  planned?: boolean;
  badge?: ReactNode;
  cta?: string;
  fields?: string[] | undefined;
  live?: ReactNode;
  onClick?: () => void;
}

/** Module / section tile. Planned modules are first-class: dimmed + non-interactive. */
export function ModuleCard({ icon, title, description, planned, badge, cta, fields, live, onClick }: ModuleCardProps) {
  const inner = (
    <>
      <div className="module-card__top">
        <span className="module-card__icon">{icon}</span>
        {badge}
      </div>
      <div className="module-card__title">{title}</div>
      <div className="module-card__desc">{description}</div>
      {fields && fields.length > 0 && (
        <div className="module-card__fields">{fields.join("  ·  ")}</div>
      )}
      {live && <div className="module-card__live">{live}</div>}
      {cta && !planned && <div className="module-card__cta">{cta}</div>}
    </>
  );

  if (planned) {
    return <div className="module-card module-card--planned" aria-disabled="true">{inner}</div>;
  }
  return (
    <button type="button" className="module-card" onClick={onClick}>
      {inner}
    </button>
  );
}
